import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ZoomOut",
  "use": "icon-ZoomOut-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ZoomOut\">\r\n    <defs>\r\n        <style type=\"text/css\"></style>\r\n    </defs>\r\n    <path d=\"M0 480m32 0l960 0q32 0 32 32l0 0q0 32-32 32l-960 0q-32 0-32-32l0 0q0-32 32-32Z\" p-id=\"3722\" fill=\"#eeeeee\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol